export function initApplyAll() {
  $(`[data-toggle-all-group]`).each((i, el) => {
    const $el = $(el);
    const $checkboxes = $el
      .parents('form')
      .find(`[name="${$el.attr('name')}"]`);

    $checkboxes.each((_, ch) => {
      $(ch).on('change', (e) => {
        if ($(ch).attr('data-toggle-all-group')) {
          return;
        }
        if (!$(ch).prop('checked')) {
          $el.prop('checked', false);
        }
      });
    })

    $el.on('change', (e) => {
      if ($el.prop('checked')) {
        $checkboxes.prop('checked', true);
      }
    });
  });
}

export function initApplyReset() {
  return false;
  $(`[data-reset-all-group]`).each((i, el) => {
    const $el = $(el);
    $el.on('change', (e) => {
      $el
        .parents('form')
        .find(`[name="${$el.attr('name')}"]`)
        .each((i, checkbox) => {
          $(checkbox).prop('checked', false);
        });
    });
  });
}